const $inject = ['$filter', 'moment'];

const timesService = ($filter, moment) => {
  const service = {
    getSelectOptions: getSelectOptions,
  };

  return service;

  function getSelectOptions(timeFormat, includeAnytime) {
    let timeOptions = [];

    if (includeAnytime) {
      timeOptions.push({
        value: moment('12:00 AM', 'h:mm A').format(timeFormat),
        label: 'Anytime',
      });
    }

    for (let i = 0; i <= 23; i++) {
      const amPm = i < 12 ? 'AM' : 'PM';
      const j = i > 12 || i === 0 ? Math.abs(i - 12) : i;
      const startHour = j + ':00 ' + amPm;
      const halfHour = j + ':30 ' + amPm;

      timeOptions.push({
        value: moment(startHour, 'h:mm A').format(timeFormat),
        label: moment(startHour, 'h:mm A').format(timeFormat),
      });

      timeOptions.push({
        value: moment(halfHour, 'h:mm A').format(timeFormat),
        label: moment(halfHour, 'h:mm A').format(timeFormat),
      });
    }

    return timeOptions;
  }
};

timesService.$inject = $inject;

export default timesService;



// WEBPACK FOOTER //
// ./src/services/timesService.js